export const PATH_DAY_PLAN_INDEX = '/day-plan';
export const PATH_DAY_PLAN_INDEX_WITH_DATE = `${PATH_DAY_PLAN_INDEX}/:date([0-9]{4}-[0-9]{2}-[0-9]{2})`;
export const PATH_DAY_PLAN_PRINT = `${PATH_DAY_PLAN_INDEX}/print/:start([0-9]{4}-[0-9]{2}-[0-9]{2})/:end([0-9]{4}-[0-9]{2}-[0-9]{2})`;
export const PATH_DIET_INTRO = `${PATH_DAY_PLAN_INDEX}/intro`;
